import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import { clearStudentAuth } from "../helper/authSession";

const initialState = {
    isLoggedIn: false,
    user: {},
    data: null,
    errorMsg: "",
    isError: false,
    token: null,
    profileFetchStatus: "idle",
}

export const getProfile = createAsyncThunk('getProfile', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getProfile();

        if (status === 200) {
            dispatch(setLoginData(data.data))
            return data.data
        }
    } catch (err) {
        const status = err.response?.status;
        if (status === 401 || status === 403) {
            clearStudentAuth();
        }
        return rejectWithValue(
            err.response?.data?.message || "'Something went wrong. Please try again later.'"
        )
    }
}
)



const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setLogin: (state, action) => {
            state.isLoggedIn = true
            state.user = action.payload
        },
        // setTwoFA: (state, action) => {
        //     state.user["2FA"] = action.payload
        // },
        setLogOut: (state, action) => {
            state.isLoggedIn = false
            state.user = {}
            state.token = ""
            state.profileFetchStatus = "idle"
            state.data = null
        },
        setLoginData: (state, action) => {
            state.data = action.payload
        },
        setToken: (state, action) => {
            state.token = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getProfile.pending, (state) => {
            state.profileFetchStatus = "loading"
            state.isError = false
        })
        builder.addCase(getProfile.fulfilled, (state, action) => {
            state.profileFetchStatus = "succeeded"
            state.isLoggedIn = true
            state.user = action.payload
            state.errorMsg = ""
        })
        builder.addCase(getProfile.rejected, (state, action) => {
            state.profileFetchStatus = "failed"
            state.isLoggedIn = false
            state.user = {}
            state.data = null
            state.token = ""
            state.errorMsg = action.payload
        })
    }
})

export const { setLogin, setTwoFA, setLogOut, setLoginData, setToken } = userSlice.actions

export default userSlice.reducer